var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"sky-blue--text"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('v-text-field',{staticClass:"font-weight-bold pt-0 mt-0",attrs:{"value":_vm.value,"readonly":"","loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }